import React from 'react';
import PropTypes from 'prop-types';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { navigateToRoute } from '../helper';
import { getNavigateSectionStyles } from '../styles';

const NavigateSection = (props) => {
  const {
    i18n,
    backRouterId,
    isShowConfirmPopup,
    isBorderInsteadOfShadow,
    ariaLabelText,
  } = props;

  const onBackLinkClick = () => {
    const { scope, siteMap } = props;
    if (isShowConfirmPopup && !confirm(i18n.getString(_TL_('Changes you made may not be saved.')))) {
      return;
    }
    navigateToRoute(scope, siteMap, backRouterId);
  };

  const classes = useDefaultStyles(getNavigateSectionStyles({ isBorderInsteadOfShadow }));

  return (
    <div className={`${classes.backToCampaign} back-to-campaign`}>
      <div
        className={`${classes.backToCampaignLink} back-to-campaign-link`}
        onClick={onBackLinkClick}
        onKeyPress={onBackLinkClick}
        role="button"
        tabIndex="0"
        aria-label={ariaLabelText}
      >
        <div style={{ display: 'inline-block', marginLeft: '16px' }}>{props.content || <div>{i18n.getString(_TL_('Campaigns > Create Campaign'))}</div>}</div>
      </div>
    </div>);
};

NavigateSection.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  backRouterId: PropTypes.string,
  content: PropTypes.element,
  isShowConfirmPopup: PropTypes.bool,
  isBorderInsteadOfShadow: PropTypes.bool,
  ariaLabelText: PropTypes.string.isRequired,
};

NavigateSection.defaultProps = {
  backRouterId: 'campaigns',
  content: undefined,
  isShowConfirmPopup: true,
  isBorderInsteadOfShadow: false,
};

export const StyledNavigateSection = withScope(withSiteMap(withI18nConsumer(NavigateSection)));
